export const sortingSVG = `<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 17V7M4 17L1 14M4 17L7 14M12 1V11M12 1L15 4M12 1L9 4" stroke="#EA5B0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
